import { Component } from 'react'
import AgentStatusPane from 'components/AgentStatusPane'
import './styles.styl'

class AgentStatusSection extends Component {
  render () {
    return (
      <div className="agent-status-toggle-container">
        <AgentStatusPane source="AgentStatusPopover" renderAgentName={false} />
      </div>
    )
  }
}

export default AgentStatusSection



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/NewAgentStatus/Popover/AgentStatusSection/index.js